// M12 + M12.1 - motricityVisualRegistry
//
// Registro de visualizaciones por gameKey. Desde 2026-05-22 todos los
// juegos comparten la misma vista UNIFICADA (estilo vrbuzzwire) que se
// adapta a los datos disponibles en el payload de cada juego. Esto:
//
//  - Da look & feel consistente al terapeuta independientemente del
//    juego que el paciente este utilizando.
//  - Evita drift entre vistas custom y vistas genericas.
//  - Cada juego se ve mejor cuanto mas se acerque a la convencion de
//    payload documentada en
//    `docs/revi-motricity/DASHBOARD_DATA_GUIDE.md`.
//
// Si en el futuro un juego necesita UI MUY especifica que no encaje en
// la vista generica, puede registrarse aqui anadiendo una entrada al
// objeto `GAME_VISUALIZATIONS`. Caso por caso, no por defecto. Sin
// entradas registradas, todos los juegos pasan por la vista generica.

import { GenericSessionView, GenericProgressionView } from "./_generic";

const GAME_VISUALIZATIONS = {
  // Vacio: todos los juegos usan la vista generica unificada.
  // NO anadir entradas sin justificacion fuerte; consumir convenciones
  // del payload es preferible a divergir en UI.
};

const GENERIC_VISUALIZATION = {
  label: "Generico",
  sessionView: GenericSessionView,
  progressionView: GenericProgressionView,
};

// Devuelve siempre una visualizacion utilizable: la custom si existe,
// o la generica como fallback. El consumidor no tiene que comprobar
// null y la UI siempre puede pintar algo si hay datos.
export function getMotricityVisualization(gameKey) {
  return GAME_VISUALIZATIONS[gameKey] || GENERIC_VISUALIZATION;
}

export function hasCustomVisualization(gameKey) {
  return Boolean(GAME_VISUALIZATIONS[gameKey]);
}
